import mixpanel from 'mixpanel-browser'
import config from '@/config'
import Sentry, { featureTags } from '@/services/sentry'

const GETTER = 'featureToggles/canSyncLandingMixpanelCookie'
const COOKIE_DAYS = 365

// The store is handed in rather than imported: the store loads a plugin that imports mixpanel.utils.
let flagStore = null

export const landingCookieName = () => `mp_${config.mixpanel.projectToken}_mixpanel`

export const syncLandingCookie = () => {
  try {
    if (!flagStore || !flagStore.getters[GETTER]) return
    const { domain } = config
    if (!domain || !window.location.hostname.includes(domain)) return
    const props = {
      distinct_id: mixpanel.get_distinct_id(),
      $device_id: mixpanel.get_property('$device_id'),
    }
    const userId = mixpanel.get_property('$user_id')
    if (userId) props.$user_id = userId
    if (!props.distinct_id || !props.$device_id) return
    const expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString()
    const secure = window.location.protocol === 'https:' ? '; secure' : ''
    document.cookie = `${landingCookieName()}=${encodeURIComponent(JSON.stringify(props))}; expires=${expires}; path=/; domain=.${domain}${secure}`
  } catch (error) {
    Sentry.captureException(error, { tags: featureTags({ featureFlag: 'RPRT-699-landing-page-view', featureName: 'landing-mixpanel-cookie-sync', taskId: 'RPRT-699' }) })
  }
}

export const installLandingCookieSync = (store) => {
  try {
    const isFirstInstall = !flagStore
    flagStore = store
    syncLandingCookie()
    if (!isFirstInstall) return
    store.watch((state, getters) => getters[GETTER], syncLandingCookie)
    // Other apps on the root domain (workspace-app) run mixpanel-js in localStorage mode, which deletes this cookie.
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') syncLandingCookie() })
  } catch (error) {
    Sentry.captureException(error, { tags: featureTags({ featureFlag: 'RPRT-699-landing-page-view', featureName: 'landing-mixpanel-cookie-sync', taskId: 'RPRT-699' }) })
  }
}
